import axiosInstance from './axios';
import { TransactionParams, TransactionsResponse } from 'types/transaction';

export const transactionService = {
  getDepositTransactions: async (params: TransactionParams): Promise<TransactionsResponse> => {
    const { page, limit, siteId, status, dateFrom, dateTo, sortField, sortValue, providerId } =
      params;

    const queryParams: any = {
      page,
      limit,
    };

    if (siteId && siteId !== 'all') queryParams.siteId = siteId;
    if (status === 'all_non_pending') {
      queryParams.status = 'created,completed,cancelled';
    } else if (status && status !== 'all') {
      queryParams.status = status;
    }
    if (providerId && providerId !== 'all') queryParams.providerId = providerId;
    if (dateFrom) queryParams.dateFrom = dateFrom;
    if (dateTo) queryParams.dateTo = dateTo;
    if (sortField) queryParams.sortField = sortField;
    if (sortValue) queryParams.sortValue = sortValue;
    if (params.userId) queryParams.userId = params.userId;

    const response = await axiosInstance.get('/admin/payments/deposit-transactions', {
      params: queryParams,
    });
    return response.data;
  },
  getWithdrawTransactions: async (params: TransactionParams): Promise<TransactionsResponse> => {
    const { page, limit, siteId, status, dateFrom, dateTo, sortField, sortValue, providerId } =
      params;

    const queryParams: any = {
      page,
      limit,
    };

    if (siteId && siteId !== 'all') queryParams.siteId = siteId;
    if (status && status !== 'all') queryParams.status = status;
    if (providerId && providerId !== 'all') queryParams.providerId = providerId;
    if (dateFrom) queryParams.dateFrom = dateFrom;
    if (dateTo) queryParams.dateTo = dateTo;
    if (sortField) queryParams.sortField = sortField;
    if (sortValue) queryParams.sortValue = sortValue;
    if (params.userId) queryParams.userId = params.userId;
    if (params.siteId && params.siteId !== 'all') queryParams.siteId = params.siteId;

    const response = await axiosInstance.get('/admin/payments/withdraw-transactions', {
      params: queryParams,
    });
    return response.data;
  },
  getPendingWithdrawals: async (params: TransactionParams): Promise<TransactionsResponse> => {
    const { page, limit, siteId, status, dateFrom, dateTo, sortField, sortValue, providerId } =
      params;

    const queryParams: any = {
      page,
      limit,
    };

    if (siteId && siteId !== 'all') queryParams.siteId = siteId;
    if (providerId && providerId !== 'all') queryParams.providerId = providerId;
    if (dateFrom) queryParams.dateFrom = dateFrom;
    if (dateTo) queryParams.dateTo = dateTo;
    if (sortField) queryParams.sortField = sortField;
    if (sortValue) queryParams.sortValue = sortValue;

    const response = await axiosInstance.get('/admin/payments/pending-withdrawals', {
      params: queryParams,
    });
    return response.data;
  },
  confirmPendingWithdrawal: async (id: string | number, receiveAmount?: string): Promise<any> => {
    const response = await axiosInstance.post(
      `/admin/payments/pending-withdrawals/${id}/confirm`,
      receiveAmount != null ? { receiveAmount } : {},
    );
    return response.data;
  },
  rejectPendingWithdrawal: async (id: string | number): Promise<any> => {
    const response = await axiosInstance.post(`/admin/payments/pending-withdrawals/${id}/reject`);
    return response.data;
  },
  confirmDepositTransaction: async (
    id: string | number,
    amountUsd?: string,
    note?: string,
  ): Promise<any> => {
    const payload: any = {};
    if (amountUsd != null) payload.amountUsd = amountUsd;
    if (note != null) payload.note = note;

    const response = await axiosInstance.post(
      `/admin/payments/deposit-transactions/${id}/confirm`,
      payload,
    );
    return response.data;
  },
  cancelDepositTransaction: async (id: string | number, note?: string): Promise<any> => {
    const payload: any = {};
    if (note != null) payload.note = note;

    const response = await axiosInstance.post(
      `/admin/payments/deposit-transactions/${id}/close-hold`,
      payload,
    );
    return response.data;
  },
};
